import { toInteger } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { ListingType, web3 } from '../utils/blockchainInteractor';
import { getSymbolERC20 } from '../utils/erc20Interactor';
function NftCard({ isMyNft = false, nft }) {
    const history = useHistory();
    const [ERCSYMBOL, setERCSYMBOL] = useState('');
    const [timer,setTimer]=useState(null);

    const init = async () => {
        setERCSYMBOL((await getSymbolERC20()));
        nft?.listingType === ListingType.AUCTION && setTimer(getTimeRemaining());
    }

    useEffect(() => {
        init();
    })

    const getTimeObj = (totalSeconds) => {
        let secondsRemaining = totalSeconds;
        const days = Math.floor(secondsRemaining / (60 * 60 * 24));
        secondsRemaining = secondsRemaining - days*24*60*60;
        const hours = Math.floor(secondsRemaining / (60 * 60));
        secondsRemaining = secondsRemaining - hours*60*60;
        const minutes = Math.floor(secondsRemaining / (60));
        secondsRemaining = secondsRemaining - minutes*60;
        const seconds = Math.floor(secondsRemaining);
        return {days, hours, minutes, seconds, totalSeconds};
    }
    const getTimeRemaining = () => {
        const today = moment();
        const endDate = moment(toInteger(nft?.endAuction) * 1000);
        const duration = moment.duration(endDate.diff(today));
        let secondsRemaining = duration.asSeconds();
        return getTimeObj(secondsRemaining);
    }

    return (
        <div onClick={() => history.push(`/nft/${nft.tokenId}`)} className="col-xl-3 col-lg-4 col-md-6">
            <div className="nft-card">
                <div className="nft-card-image">
                    <img src={nft?.image || '/assets/img/nft-top-image.png'} alt="" className="img-fluid" />
                </div>
                <div className="nft-card-content">
                    <div className="nft-txt-heading">
                        <h6>{nft?.name || 'Demo Name'}</h6>
                    </div>
                    {
                        !isMyNft && nft?.listingType === ListingType.MARKETPLACE &&
                        <div className="nft-stock">
                            <a role={"button"} className="nft-eth">{nft?.price && `${web3.utils.fromWei(nft?.price)} ${ERCSYMBOL}`}</a>
                        </div>
                    }

                    {
                        !isMyNft && nft?.listingType === ListingType.AUCTION &&
                    <div className="d-flex justify-content-between flex-column">
                          {
                                                timer?.totalSeconds > 0 ? 
                    <div className="d-flex justify-content-around">
                        <div className="d-flex flex-column mr-2">
                            <span className="hour">{timer?.days || '00'}</span>
                            <span>Days</span>
                        </div>
                        <div className="d-flex flex-column mr-2">
                            <span className="hour">{timer?.hours || '00'}</span>
                            <span>Hours</span>
                        </div>
                        <div className="d-flex flex-column mr-2">
                            <span className="minutes">{timer?.minutes || '00'}</span>
                            <span>Mins</span>
                        </div>
                        <div className="d-flex flex-column mr-2">
                            <span className="seconds">{timer?.seconds || '00'}</span>
                            <span>Sec</span>
                        </div>
                    </div> : <p>Time up!!</p> }

                        <div className="nft-stock d-flex mt-4">
                            <span>Current bid:</span>
                            <a role={"button"} className="nft-eth">{nft?.currentBidPrice && `${web3.utils.fromWei(nft?.currentBidPrice)} ${ERCSYMBOL}`}</a>
                        </div>
                        </div>
                    }
                    {
                        !isMyNft && (nft?.listingType === ListingType.MARKETPLACE || nft?.listingType === ListingType.AUCTION) && <div className="nft-customers">
                            <a role={"button"} className="delist-itm-btn">View</a>
                        </div>
                    }
                    {
                        isMyNft && nft?.listingType === ListingType.MARKETPLACE && <div className="nft-customers">
                            <a role={"button"} className="delist-itm-btn">Delist Item</a>
                        </div>
                    }
                    {
                        isMyNft && nft?.listingType === ListingType.NOT_LISTED && <div className="nft-customers">
                            <a role={"button"} className="delist-itm-btn">List Item</a>
                        </div>
                    }

                </div>
            </div>
        </div>
    )
}

export default NftCard;
